export const ACTIVATION = 'ACTIVATION';
export const AUTO_CLEAN = 'AUTO_CLEAN';
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const UPDATE_FIRMWARE = 'UPDATE_FIRMWARE';
export const SYNCHRONIZE = 'SYNCHRONIZE';
export const DATA_COLLECTION = 'DATA_COLLECTION';
